import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ProductSelector from '../presenters/ProductSelector';
import ProductOrderList from '../presenters/ProductOrderList';
import { getFormValues } from 'redux-form';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getProductList,
  addOrderProduct,
  deleteOrderProduct,
  setDiscount,
  setCustomDiscount,
  setSettingDiscount,
  setQuantity,
  setInitialProductOrderList,
  setCustomDescription,
  setProductAmount,
} from '../../../action/product';
import { setVoltage } from '../../../action/customer';
import { productList, discount } from '../../../reducer/product';

import SalesDiscountSetting from '../SalesDiscountSetting';
import SalesAmountSetting from '../SalesAmountSetting';
import { setRate } from '../presenters/setRate';

const propTypes = {};

const defaultProps = {};

function createWarning(funcName) {
  return () => console.warn((funcName = ' is not defined'));
}

class Product extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    // 저장된 주문을 불러온 뒤 자동 할인 티어를 처음 계산했는지 여부.
    // 첫 계산은 기준선만 잡고(전역 할인율 동기화) 항목은 건드리지 않는다.
    this.autoDiscountBaselineDone = false;

    this.currencyExceptionHandler = this.currencyExceptionHandler.bind(this);
    this.discountExceptionHandler = this.discountExceptionHandler.bind(this);
    this.amountExceptionHandler = this.amountExceptionHandler.bind(this);
    this.calculateDiscountFromAmount =
      this.calculateDiscountFromAmount.bind(this);
  }

  currencyExceptionHandler() {
    if (this.props.selectedCustomer.Currency == undefined) return 'USD';
    return this.props.selectedCustomer.Currency;
  }

  discountSetting(nextProps) {
    // 티어 기준 합계는 항상 양수여야 한다.
    // - 반품(SOType 8)은 수량이 음수로 저장되므로 절대값을 쓴다. 그대로 더하면
    //   합계가 음수가 되어 아래 조건을 모두 빠져나가 최저 티어(47%)로 떨어진다.
    // - USDRetail이 NULL인 상품(CS_Parts 등)이 한 줄이라도 있으면 합계가 NaN이 되어
    //   역시 47%로 떨어지므로, 값이 없는 줄은 합계에서 제외한다.
    const total = nextProps.productOrderList.reduce((a, b) => {
      const retail = Number(b.product.USDRetail);
      const quantity = Math.abs(Number(b.quantity));
      if (!isFinite(retail) || !isFinite(quantity)) return a;
      return a + retail * quantity;
    }, 0);

    if (total >= 60000) return 60;
    else if (total >= 40000 && total < 60000) return 55;
    else if (total >= 20000 && total < 40000) return 52;
    else if (total >= 10000 && total < 20000) return 50;
    else if (total >= 0 && total < 10000) return 47;
    else return 47;
  }

  discountExceptionHandler(discount, nextProps) {
    let Discount = discount;

    if (nextProps.company == 'Aurender Inc.') {
      if (nextProps.selectedCustomer.AccountID != undefined) {
        SalesDiscountSetting.AurenderInc.byCountry.forEach((country) => {
          if (nextProps.billingCountry == country.Country)
            Discount = country.Discount;
        });

        SalesDiscountSetting.AurenderInc.byCompany.forEach((company) => {
          if (nextProps.selectedCustomer.AccountID == company.Company)
            Discount = company.Discount;
        });
      }
      return Discount;
    } else if (nextProps.company == 'Aurender America Inc.') {
      Discount = SalesDiscountSetting.AurenderAmericaInc.Discount;
      return Discount;
    } else return Discount;
  }

  updateProductOrdersForSalesOrderType(salesOrderType) {
    this.props.productOrderList.forEach((productOrder) => {
      const newQuantity =
        salesOrderType === 8
          ? -Math.abs(productOrder.quantity)
          : Math.abs(productOrder.quantity);
      if (newQuantity !== productOrder.quantity) {
        this.props.setQuantity(productOrder.id, newQuantity);
      }
    });
  }

  amountExceptionHandler(nextProps) {
    if (this.props.company == 'Aurender Inc.') {
      if (nextProps.selectedCustomer.AccountID != undefined) {
        SalesAmountSetting.AurenderInc.byCountry.forEach((country) => {
          if (country.Country == nextProps.billingCountry) {
            nextProps.productOrderList.forEach((productOrder) => {
              country.Prices.forEach((product) => {
                if (
                  product.Model == productOrder.product.Model.trim() &&
                  product.HDD == productOrder.product.HDD.trim()
                ) {
                  if (productOrder.product.Model.trim() == 'N100C') {
                    if (product.SSD == productOrder.product.SSD.trim()) {
                      let discount = 0;
                      discount = this.calculateDiscountFromAmount(
                        productOrder,
                        this.currencyExceptionHandler(),
                        product.Amount
                      );
                      if (
                        discount != productOrder.discount &&
                        productOrder.isCustomDiscount == false
                      )
                        this.props.setSettingDiscount(
                          productOrder.id,
                          discount
                        );
                    }
                  } else {
                    let discount = 0;
                    discount = this.calculateDiscountFromAmount(
                      productOrder,
                      this.currencyExceptionHandler(),
                      product.Amount
                    );
                    if (
                      discount != productOrder.discount &&
                      productOrder.isCustomDiscount == false
                    )
                      this.props.setSettingDiscount(productOrder.id, discount);
                  }
                }
              });
            });
          }
        });

        SalesAmountSetting.AurenderInc.byCompany.forEach((company) => {
          if (company.Company == nextProps.selectedCustomer.AccountID) {
            nextProps.productOrderList.forEach((productOrder) => {
              company.Prices.forEach((product) => {
                if (
                  product.Model == productOrder.product.Model.trim() &&
                  product.HDD == productOrder.product.HDD.trim()
                ) {
                  if (productOrder.product.Model.trim() == 'N100C') {
                    if (product.SSD == productOrder.product.SSD.trim()) {
                      let discount = 0;
                      discount = this.calculateDiscountFromAmount(
                        productOrder,
                        this.currencyExceptionHandler(),
                        product.Amount
                      );
                      if (
                        discount != productOrder.discount &&
                        productOrder.isCustomDiscount == false
                      )
                        this.props.setSettingDiscount(
                          productOrder.id,
                          discount
                        );
                    }
                  } else {
                    let discount = 0;
                    discount = this.calculateDiscountFromAmount(
                      productOrder,
                      this.currencyExceptionHandler(),
                      product.Amount
                    );
                    if (
                      discount != productOrder.discount &&
                      productOrder.isCustomDiscount == false
                    )
                      this.props.setSettingDiscount(productOrder.id, discount);
                  }
                }
              });
            });
          }
        });
      }
    } else if (this.props.company == 'Aurender America Inc.') {
    }
  }

  calculateDiscountFromAmount(productOrder, currency, amount) {
    let discount =
      100 -
      (amount /
        setRate(
          {
            AACost: productOrder.product.AACost,
            USDRetail: productOrder.product.USDRetail,
            KRWRetail: productOrder.product.KRWRetail,
          },
          currency,
          this.props.company,
          this.props.billingCountry
        )) *
        100;
    return discount;
  }

  componentDidMount() {
    this.props.getProductList();

    // Aurender America Inc. 회사인 경우 voltage를 120V로 강제 설정
    if (this.props.company === 'Aurender America Inc.') {
      this.props.setVoltage('120V');
    }
  }

  // 자동 할인 티어를 지금 계산해도 되는지.
  // 저장된 주문을 불러온 경우에는 고객 정보(AccountID)가 도착하기 전에 계산하면
  // 국가/거래처별 고정 할인이 빠진 값이 나와 저장된 할인율을 잘못 덮어쓴다.
  // 상품 목록과 고객 정보는 병렬로 로드되므로 순서가 보장되지 않는다.
  isAutoDiscountReady(nextProps) {
    if (nextProps.productOrderList.length === 0) return false;
    if (!nextProps.isHydratedOrder) return true;
    if (nextProps.selectedCustomer.AccountID != undefined) return true;
    // 폼 데이터 로딩이 끝났는데도 고객 정보가 없으면(조회 실패 등) 더 기다리지 않는다.
    // 계속 막으면 전역 할인율이 0에 머물러, 이후 담는 상품이 할인 0%로 들어간다.
    return !nextProps.isSalesOrderFormDataLoading;
  }

  componentWillReceiveProps(nextProps) {
    // 인보이스 화면에서는 자동 할인 티어를 다시 계산하지 않는다.
    // 부분 인보이스는 SO의 일부 항목만 담고 있어 합계가 작게 잡히고, 그러면
    // SO에서 확정된 할인율보다 낮은 티어가 적용되어 과다 청구가 된다.
    // 인보이스에서는 ProductSelector가 숨겨져 새 상품을 넣을 수도 없으므로
    // 티어를 다시 매길 이유가 없다.
    if (!this.props.isInvoice && this.isAutoDiscountReady(nextProps)) {
      const discount = this.discountExceptionHandler(
        this.discountSetting(nextProps),
        nextProps
      );
      // 불러온 직후 첫 계산은 기준선만 잡는다. 저장 당시 확정된 할인율/금액을
      // 화면을 열었다는 이유만으로 덮어쓰지 않기 위함이다. 이후 사용자가 항목을
      // 추가/삭제해서 티어가 바뀌면 그때부터는 정상적으로 전 항목에 반영된다.
      const applyToLines =
        this.autoDiscountBaselineDone || !nextProps.isHydratedOrder;
      if (discount != this.props.discount)
        this.props.setDiscount(discount, applyToLines);
      this.autoDiscountBaselineDone = true;
      // 특가(SalesAmountSetting) 적용도 같은 이유로 기준선 단계에서는 건너뛴다.
      // setSettingDiscount는 항목의 discount/amount를 직접 덮어쓰기 때문이다.
      if (applyToLines) this.amountExceptionHandler(nextProps);
    }

    // Check if salesOrderType has changed
    if (this.props.salesOrderType !== nextProps.salesOrderType) {
      this.updateProductOrdersForSalesOrderType(nextProps.salesOrderType);
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.props.isInvoice ? null : (
          <ProductSelector
            productList={this.props.productList}
            onAdd={this.props.addOrderProduct}
            discount={this.props.discount}
            voltage={this.props.voltage}
            selectedCustomer={this.props.selectedCustomer}
            company={this.props.company}
          />
        )}

        <ProductOrderList
          productOrderList={this.props.productOrderList}
          selectedCustomer={this.props.selectedCustomer}
          discount={this.props.discount}
          deleteOrderProduct={this.props.deleteOrderProduct}
          setDiscount={this.props.setDiscount}
          setCustomDiscount={this.props.setCustomDiscount}
          setQuantity={this.props.setQuantity}
          setCustomDescription={this.props.setCustomDescription}
          setProductAmount={this.props.setProductAmount}
          billingCountry={this.props.billingCountry}
          salesOrderType={this.props.salesOrderType}
        />
      </React.Fragment>
    );
  }
}

export default connect(
  (state) => ({
    productList: state.productList,
    productOrderList: state.productOrderList,
    discount: state.discount,
    isHydratedOrder: state.isHydratedOrder,
    isSalesOrderFormDataLoading: state.isSalesOrderFormDataLoading,
    selectedCustomer: state.selectedCustomer.billingCustomer,
    billingCountry: state.billingCountry,
    voltage: state.voltage,
    company: state.company,
    salesOrderType: getFormValues('SalesOrder')(state)?.SOType,
  }),
  (dispatch) => ({
    getProductList: bindActionCreators(getProductList, dispatch),
    addOrderProduct: bindActionCreators(addOrderProduct, dispatch),
    deleteOrderProduct: bindActionCreators(deleteOrderProduct, dispatch),
    setDiscount: bindActionCreators(setDiscount, dispatch),
    setCustomDiscount: bindActionCreators(setCustomDiscount, dispatch),
    setSettingDiscount: bindActionCreators(setSettingDiscount, dispatch),
    setQuantity: bindActionCreators(setQuantity, dispatch),
    setCustomDescription: bindActionCreators(setCustomDescription, dispatch),
    setProductAmount: bindActionCreators(setProductAmount, dispatch),
    setInitialProductOrderList: bindActionCreators(
      setInitialProductOrderList,
      dispatch
    ),
    setVoltage: bindActionCreators(setVoltage, dispatch),
    dispatch,
  })
)(Product);

Product.PropTypes = propTypes;
Product.defaultProps = defaultProps;
